<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
    
    <mat-spinner [diameter]="250"></mat-spinner>
    <!--
    <img src="assets/images/logo_cns_branco.png">

    <span class="loading-message">Carregando... por favor, aguarde.</span>
    -->
    
  </div>
</div>